import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiAndroid,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
} from "react-icons/di";
import { SiFirebase, SiFlutter, SiTailwindcss, SiRedux } from "react-icons/si";
import ScrollReveal from "../ScrollReveal/ScrollReveal";

const stack = [
  { label: "Flutter", icon: <SiFlutter /> },
  { label: "Tailwind CSS", icon: <SiTailwindcss /> },
  { label: "Node.js", icon: <DiNodejs /> },
  { label: "React", icon: <DiReact /> },
  { label: "MongoDB", icon: <DiMongodb /> },
  { label: "Android", icon: <DiAndroid /> },
  { label: "Git", icon: <DiGit /> },
  { label: "Firebase", icon: <SiFirebase /> },
  { label: "Redux", icon: <SiRedux /> },
  { label: "JavaScript", icon: <DiJavascript1 /> },
];

function Techstack() {
  return (
    <Row className="stack-grid">
      {stack.map((item) => (
        <Col xs={6} md={4} xl={2} key={item.label}>
          <ScrollReveal className="tech-icons" delay={stack.indexOf(item) * 55} distance={16}>
            <span>{item.icon}</span>
            <small>{item.label}</small>
          </ScrollReveal>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
